/**
 * `humanbehavior-js/react` - the bundled React integration.
 *
 * Binds the shared provider to the recorder that ships inside the customer's
 * build. This is the entry every existing install resolves to, so its exports
 * and behavior must not change; `humanbehavior-js/react/auto` is where the
 * auto-updating variant lives.
 */

import { HumanBehaviorTracker, logError, logWarn, logDebug } from "./browser";
import { createHumanBehaviorReact } from "./factory";

const react = createHumanBehaviorReact(HumanBehaviorTracker, {
  error: logError,
  warn: logWarn,
  debug: logDebug,
});

export const HumanBehaviorProvider = react.HumanBehaviorProvider;
export const useHumanBehavior = react.useHumanBehavior;
export const useRedaction = react.useRedaction;
export const useUserTracking = react.useUserTracking;
export const HumanBehaviorErrorBoundary = react.HumanBehaviorErrorBoundary;
/**
 * This used to be a class declaration, which made the name usable as a type as
 * well as a value - `useRef<HumanBehaviorErrorBoundary>(null)` compiled. Coming
 * out of a factory it is only a value, so the alias keeps that half of the
 * existing published surface intact.
 */
export type HumanBehaviorErrorBoundary = InstanceType<typeof react.HumanBehaviorErrorBoundary>;

export { captureNextError } from "./factory";
export type { IdentifyUserArgs } from "./factory";

// Export the tracker class for direct use
export { HumanBehaviorTracker };
